var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsersShared(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 12.8667,
    height: 11.7,
    viewBox: "0 0 12.8667 11.7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12.2667 11.1V9.93333C12.2667 8.84609 11.5231 7.93254 10.5167 7.67351M8.475 0.769609C9.33012 1.11575 9.93333 1.9541 9.93333 2.93333C9.93333 3.91257 9.33012 4.75091 8.475 5.09706M9.35 11.1C9.35 10.0128 9.35 9.4692 9.17239 9.0404C8.93557 8.46867 8.48133 8.01443 7.9096 7.77761C7.4808 7.6 6.9372 7.6 5.85 7.6H4.1C3.0128 7.6 2.4692 7.6 2.04041 7.77761C1.46867 8.01443 1.01443 8.46867 0.777615 9.0404C0.6 9.4692 0.6 10.0128 0.6 11.1M7.30833 2.93333C7.30833 4.222 6.26366 5.26667 4.975 5.26667C3.68634 5.26667 2.64167 4.222 2.64167 2.93333C2.64167 1.64467 3.68634 0.6 4.975 0.6C6.26366 0.6 7.30833 1.64467 7.30833 2.93333Z",
    stroke: "#575756",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersShared);
export default __webpack_public_path__ + "static/media/users-shared.85ab5fdedb774d8f3f8c7525934a1453.svg";
export { ForwardRef as ReactComponent };